import { DEFAULT_AVATAR_URL, WP_DirUser } from '../../model/models';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import {
  useTags,
  useUserGroup,
  useUserInformations,
} from '../../hooks/WPHooks';

interface DirectoryWidgetProps {
  title: string;
  tagSlugs: Array<string>;
  house?: number;
  nbUserToDisplay?: number;
}

const DirectoryWidget: React.FC<DirectoryWidgetProps> = ({
  title,
  tagSlugs,
  house,
  nbUserToDisplay,
}) => {
  const { userGroup, groupTagIds } = useUserGroup(
    tagSlugs,
    house,
    nbUserToDisplay
  );

  const nbUTD = nbUserToDisplay ? nbUserToDisplay : 9;

  const usersList =
    userGroup.length > nbUTD ? [...userGroup].splice(0, nbUTD) : userGroup;

  const { tags: roles } = useTags('role');

  const { user } = useUserInformations();

  const getUserRole = (dirUser: WP_DirUser) => {
    let ret = '';
    if (dirUser.acf.tags && roles) {
      const userRoles = roles.filter((role) => {
        const roleId = role.id;
        const find = dirUser.acf.tags.find((usertag) => {
          const linkedSlug = role.acf?.linkedtag?.slug || '';
          return usertag.term_id === roleId && tagSlugs.includes(linkedSlug);
        });
        return find ? true : false;
      });

      if (userRoles.length > 0) {
        const userPost = userRoles[0];
        ret = userPost.name;
        if (userPost.acf.label && user) {
          const postLang = userPost.acf.label.find(
            (translation) => translation.lang === user.acf.locale.split('_')[0]
          );
          if (postLang) {
            ret = postLang.value;
          }
        }
      }
    }
    return ret;
  };

  const getSpecificSearch = () => {
    let ret = '';
    if (house) {
      ret = ret + 'h=' + house;
    }

    if (groupTagIds.length > 0) {
      if (ret !== '') {
        ret = ret + '&';
      }
      ret = ret + 't=';
      groupTagIds.forEach((id, index) => {
        if (index === 0) {
          ret = ret + id;
        } else {
          ret = ret + ',' + id;
        }
      });
    }

    return ret;
  };

  const specificSearch = getSpecificSearch();
  if (usersList.length === 0) {
    return <></>;
  }
  return (
    <Link
      className="flex flex-col py-6 bg-none"
      to={'/search/users/' + specificSearch}
    >
      <div className="flex justify-between items-center py-4">
        <h4 className="font-bold text-lg text-black !mb-0">
          <FormattedMessage id={title} />
        </h4>
        <span className="text-primary font-semibold">
          <FormattedMessage id="See all" />
        </span>
      </div>
      <div className="grid gap-3 grid-cols-3">
        {usersList.map((dirUser, index) => (
          <div
            key={'user_' + index}
            className="flex flex-col justify-start items-center h-32"
          >
            <img
              className="!inline-block !h-20 !w-20 min-h-[5rem] !rounded-full !object-cover"
              src={
                dirUser.acf.photo !== ''
                  ? dirUser.acf.photo
                  : DEFAULT_AVATAR_URL
              }
              alt=""
            />
            <span className="font-semibold text-sm text-center mt-2 text-black">
              {dirUser.name.split(' ')[0]}
            </span>
            <span className="italic text-xs text-gray-600 text-center">
              {getUserRole(dirUser)}
            </span>
          </div>
        ))}
      </div>
    </Link>
  );
};

export default DirectoryWidget;
